import React from 'react';
import Modal from './modal';

const ConfirmationModal = props => {
  let {
    headText,
    bodyText,
    proceedTextShow,
    buttonShow,
    handleClickYes,
    askConfirmation,
    setConfirmation
  } = props;
  return (
    <React.Fragment>
      <Modal
        show={askConfirmation}
        setShow={setConfirmation}
        noCloseBtn={false}
      >
        <div>
          <div className="w-full text-center">
            {headText && (
              <p className="font-roboto text-lg font-bold text-black-400 border-b border-grey-200 text-center pb-4 pt-2">
                {headText}
              </p>
            )}
          </div>
          <div className="w-full text-center">
            {bodyText && (
              <p className="font-roboto font-normal text-black-400 text-center py-2 mt-2 normal-case">
                {bodyText}
              </p>
            )}
            {proceedTextShow && (
              <p className="font-roboto font-normal text-sm text-red-400 text-center mt-1">
                Are you sure you want to proceed ?
              </p>
            )}
          </div>
          {buttonShow && (
            <div className="w-full flex justify-end gap-6 mt-7">
              <div>
                <button
                  type="button"
                  className="w-19 bg-tealCol-100 border text-white rounded-md font-roboto font-normal px-3 py-2 hover:bg-green-1100"
                  onClick={handleClickYes}
                >
                  Yes
                </button>
              </div>
              <div>
                <button
                  type="button"
                  className="w-19 text-black-500 px-3 py-2 border border-grey-200 rounded-md font-roboto font-normal hover:bg-grey-100"
                  onClick={() => setConfirmation(false)}
                >
                  No
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default ConfirmationModal;
